//#region src/components/ScalarDropdown/ScalarDropdownDivider.vue?vue&type=script&lang.ts
/**
* Scalar dropdown divider component
*
* Used to create a divider between items in the ScalarDropdown component
*
* @example
* <ScalarDropdown>
*   ...
*   <template #items>
*     <ScalarDropdownItem>Item 1</ScalarDropdownItem>
*     <ScalarDropdownItem>Item 2</ScalarDropdownItem>
*     <ScalarDropdownDivider />
*     <ScalarDropdownItem>Item 3</ScalarDropdownItem>
*   </template>
* </ScalarDropdown>
*/
var ScalarDropdownDivider_vue_vue_type_script_lang_default = {};
//#endregion
export { ScalarDropdownDivider_vue_vue_type_script_lang_default as default };

//# sourceMappingURL=ScalarDropdownDivider.vue_vue_type_script_lang.js.map